import { render, staticRenderFns } from "./workcenter-initial-test.vue?vue&type=template&id=c2fa0396&"
import script from "./js/workcenter-initial-test.js?vue&type=script&lang=js&"
export * from "./js/workcenter-initial-test.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports